const routes = [
  {
    path: '/templates',
    name: 'templates',
    component: () => import('./index.vue'),
    meta: {
      title: 'Шаблоны ответов',
    },
  },
];

export default routes;
